import Link from "next/link";
import React from "react";
import { HiMail } from "../icons/sharedIcons";
import { useAuth } from "../../context/AuthProvider";
import { requireIdToken } from "../../utils/firebaseAuth";
import axios from "axios";
import { useQuery } from "react-query";

const MessageIcon = () => {
  const fetchUnreadCount = async (updateUser) => {
    const token = await requireIdToken();
    const response = await axios.get("/api/message/getUnreadMessageCount", {
      headers: { Authorization: token },
    });
    updateUser({
      unreadCount: response.data.unreadCount,
    });
    return response.data.unreadCount;
  };

  const { user, updateUser } = useAuth();

  useQuery(
    ["unreadCount", user?.firebaseUid],
    () => fetchUnreadCount(updateUser),
    {
      enabled: !!user?.firebaseUid,
      //   refetchInterval: 60000,
      refetchOnWindowFocus: true,
    },
  );

  return (
    <Link
      href="/messages"
      aria-label={`Messages${user?.unreadCount > 0 ? ` (${user.unreadCount} unread)` : ""}`}
      className="tw-relative tw-flex tw-h-11 tw-w-11 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-bg-jam-lav tw-text-jam-ink tw-transition-colors hover:tw-text-jam-purple"
    >
      <HiMail size={21} />
      {user?.unreadCount > 0 && (
        <span className="tw-absolute tw--right-0.5 tw--top-0.5 tw-flex tw-h-[20px] tw-min-w-[20px] tw-items-center tw-justify-center tw-rounded-full tw-border-2 tw-border-solid tw-border-white tw-bg-jam-purple tw-px-1 tw-text-[10px] tw-font-extrabold tw-tabular-nums tw-text-white">
          {user?.unreadCount}
        </span>
      )}
    </Link>
  );
};

export default MessageIcon;
